import React, { MutableRefObject, RefObject, createRef } from "react";
import classes from "../style/classes";
import MFACodeForm from "./MFACodeForm";
import MFASetupSuccess from "./MFASetupSuccess";
import Stage from "./stage";
import MFASetupModalHeader from "./MFASetupModalHeader";
import MFASetupModalFooter from "./MFASetupModalFooter";

interface MFASetupModalProps {
  isOpen: boolean;
  onAcknowledge: VoidFunction;
  onClose: VoidFunction;
}

interface MFASetupModalState {
  stage: Stage;
}

export default class MFASetupModal extends React.Component<
  MFASetupModalProps,
  MFASetupModalState
> {
  contentRef: RefObject<HTMLDivElement>;

  listenerRef: MutableRefObject<(e: MouseEvent) => void>;

  constructor(props) {
    super(props);

    this.state = {
      stage: Stage.Code,
    };

    this.contentRef = createRef();
    this.listenerRef = createRef();
  }

  componentDidMount(): void {
    const listener = (e): void => {
      if (
        this.state.stage === Stage.Code &&
        !this.contentRef.current.contains(e.target)
      ) {
        this.props.onClose();
      }
    };

    document.addEventListener("click", listener);

    this.listenerRef.current = listener;
  }

  componentWillUnmount(): void {
    document.removeEventListener("click", this.listenerRef.current);
  }

  render(): JSX.Element {
    return (
      <div className={classes("ds-modal", { "is-visible": this.props.isOpen })}>
        <div className="modal__overlay" />
        <div className="modal__container">
          <div className="modal__content w-lg" ref={this.contentRef}>
            <MFASetupModalHeader
              onClose={this.props.onClose}
              stage={this.state.stage}
            />

            <div className="modal__body">
              {this.state.stage === Stage.Code ? (
                <MFACodeForm onSuccess={this.handleSubmitSuccess} />
              ) : (
                <MFASetupSuccess />
              )}
            </div>

            {this.state.stage === Stage.Success && (
              <MFASetupModalFooter onClose={this.props.onAcknowledge} />
            )}
          </div>
        </div>
      </div>
    );
  }

  handleSubmitSuccess = (): void => {
    this.setState({ stage: Stage.Success });
  };
}
